module.exports = __webpack_public_path__ + "media/images/avion-60f65afa2fdf0eda47b10e558ba37d75.svg";